import { httpClient } from '../http/httpClient'

export const checkCodeIsAvailable = async (code: string) => {
  const { data } = await httpClient
    .get<boolean>(`/team/checkCode/${code}`)
    .catch((err) => {
      throw err?.response?.data || err
    })

  return data
}
